import { memo } from "react";

export const FloppyIcon = memo(() => (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M7 41H41V13.6709L34.1139 7H7V41Z"
      fill="#9B9B9A"
      stroke="black"
      strokeLinejoin="round"
    />
    <rect
      x="13"
      y="25.0479"
      width="22"
      height="16"
      fill="#FFB655"
      stroke="black"
      strokeLinejoin="round"
    />
    <path d="M16 33H32M16 37H32" stroke="black" strokeLinejoin="round" />
    <path
      d="M31.7139 7.00781C31.9418 7.05434 32.1132 7.25641 32.1133 7.49805V16.501C32.1133 16.7771 31.8894 17.001 31.6133 17.001H16.5C16.2239 17.001 16 16.7771 16 16.501V7.49805L16.0098 7.39746C16.0563 7.16956 16.2583 6.99805 16.5 6.99805H24.8652V14.0439H28.8652V6.99805H31.6133L31.7139 7.00781Z"
      fill="#D9D9D9"
      stroke="black"
      strokeLinejoin="round"
    />
    <rect
      x="13"
      y="25"
      width="22"
      height="4"
      fill="#EA5A47"
      stroke="black"
      strokeLinejoin="round"
    />
  </svg>
));
